exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".p-0 {\n  padding: 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// A:/CM/links-ui/cm-ui-app-links/src/app/app.component.scss
// module id = ../../../../../src/app/app.component.scss
// module chunks = main